
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/record-matching",
      function () {
        return require("private-next-pages/syncs/record-matching.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/record-matching"])
      });
    }
  